module.exports = __webpack_public_path__ + "static/media/WhatsApp.ba90dc77.svg";